export default function Index() {
  return <div>index</div>;
}
